import React, { useCallback } from "react";
import { useRouter } from 'next/router';
import { useAppDispatch, useAppSelector } from 'redux-store';
import cn from 'classnames';

import { goNext } from 'redux-store/slices/survey';

import Button from 'components/basic/Button';

import styles from './styles.module.scss';

type Props = {
  text: string;
  theme?: string;
  className?: string | undefined;
  disabled: boolean;
  onClick?: (...args: any[]) => void;
//   back?: NavButtonConfig;
};

const surveyList = ['height', 'weight', 'weightGoal'];

export default function SurveyBackButton({
  text,
  theme = 'white',
  className,
  disabled,
  onClick
}: Props) {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { nextPageUrl } = useAppSelector((state) => state.onboarding);

  const onClickNextButton = () => {
    if (typeof onClick !== 'function') {
      dispatch(goNext());
      router.push(nextPageUrl);
    }
    else {
      onClick();
    }
  }

  return (
    <div className={cn(styles.nextButtonWrapper, {[styles.darkTheme]: theme === 'dark'})}>
      <Button
        size="small"
        look="secondary"
        className={cn(styles.nextButton, className)}
        disabled={disabled}
        onClick={onClickNextButton}
      >
        {text}
      </Button>
    </div>
  );
}
